import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer/Footer";

const sectionSx = { mt: 4 };
const bodySx = { lineHeight: 1.8, mb: 1.5, fontFamily: "Roboto, Helvetica, Arial, sans-serif" };

const AccessibilityStatement = () => {
  return (
    <>
      <Helmet>
        <title>Accessibility Statement | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Đông Hưng Viên Bakery's commitment to a website accessible to all visitors."
        />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          background: "#fff",
          pt: { xs: 14, md: 18 },
          pb: 8,
        }}
      >
        <Box sx={{ maxWidth: "860px", width: "90%", color: "#222" }}>
          <Typography variant="h3" sx={{ fontSize: { xs: "28px", md: "36px" }, fontWeight: 700, mb: 1 }}>
            Accessibility Statement
          </Typography>
          <Typography sx={{ color: "#666", mb: 3 }}>Effective date: August 4, 2026</Typography>

          <Typography sx={bodySx}>
            Đông Hưng Viên Bakery (Dong Hung Vien, Inc.) is committed to making
            donghungvienbakery.com usable by everyone, including people who use assistive
            technology such as screen readers, screen magnification, or keyboard-only navigation.
            We are working to align the Site with the Web Content Accessibility Guidelines (WCAG)
            2.1, Level AA.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Measures We Have Taken</Typography>
          <Box component="ul" sx={{ pl: 3, ...bodySx }}>
            <li>Descriptive text alternatives for meaningful images;</li>
            <li>Labels associated with form fields on our contact, booking, and wholesale forms;</li>
            <li>Descriptive names for icon-only links and buttons (e.g., social media links);</li>
            <li>A “skip to main content” link for keyboard users; and</li>
            <li>Ongoing review of new pages as they are added.</li>
          </Box>

          <Typography variant="h5" sx={sectionSx}>Known Limitations</Typography>
          <Typography sx={bodySx}>
            No website is perfectly accessible at all times. If you encounter a page or feature that
            is difficult to use with your assistive technology, please let us know using the contact
            information below so we can address it.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Contact Us</Typography>
          <Typography sx={bodySx}>
            If you have trouble accessing any part of this Site, or need information in an alternate
            format, please contact us at{" "}
            <MuiLink href="tel:7148914404">(714) 891-4404</MuiLink>, by email at{" "}
            <MuiLink href="mailto:info@donghungvienbakery.com">info@donghungvienbakery.com</MuiLink>,
            in person at 8536 Westminster Blvd, Westminster, CA 92683, or via our{" "}
            <MuiLink component={Link} to="/contact">Contact page</MuiLink>. We will do our best to
            respond promptly and provide the information or service you need.
          </Typography>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default AccessibilityStatement;
